import React, { useState } from "react";
import product1 from "../../assets/images/product-01.jpg";
import product2 from "../../assets/images/product-02.jpg";
import product3 from "../../assets/images/product-03.jpg";
import product4 from "../../assets/images/product-04.jpg";
import product5 from "../../assets/images/product-05.jpg";
import product6 from "../../assets/images/product-06.jpg";
import ProductDetailsModal from "../../components/ProductDetails/ProductDetailsModal";
import { useProducts } from "../../context/ProductContext";
import { IMG_URL } from "../../config/config";
import { Link } from "react-router-dom";

const HomeProduct = () => {
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [showModal, setShowModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const { products, categories } = useProducts();
  const handleQuickView = (e, product) => {
    e.preventDefault();
    setSelectedProduct(product);
    setShowModal(true);
  };
  const filteredProducts = products.filter((p) => {
    const matchesCategory =
      selectedCategory === "all" ||
      p.category_id?.toString() === selectedCategory.toString();

    return matchesCategory;
  });

  return (
    <section className="bg-light py-5">
      <div className="container">
        <div className="mb-4">
          <h3 className="h3 text-dark">Product Overview</h3>
        </div>

        <div className="d-flex flex-wrap justify-content-start gap-4 category-nav mb-4">
          {[{ category_name: "All", category_id: "all" }, ...categories].map(
            (cat, idx) => {
              const value = cat.category_id?.toString();
              return (
                <div
                  key={idx}
                  className={`category-item ${
                    selectedCategory === value
                      ? "fw-bold text-dark border-bottom"
                      : "text-muted"
                  }`}
                  onClick={() => setSelectedCategory(value)}
                  role="button"
                >
                  {cat.category_name}
                </div>
              );
            }
          )}
        </div>

        {/* Product Grid */}
        <div className="row g-4">
          {filteredProducts.length > 0 ? (
            [...filteredProducts] // Create a shallow copy to avoid mutating state
              .sort(() => Math.random() - 0.5) // Randomize order
              .slice(0, 20) // Take only first 20
              .map((product) => (
                <div
                  key={product.id}
                  className="col-12 col-sm-6 col-md-4 col-lg-3"
                >
                  <div className="product-card position-relative overflow-hidden">
                    <div className="product-img-wrapper">
                      <div
                        style={{
                          width: "100%",
                          height: "250px",
                          overflow: "hidden",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          background: "#f8f8f8",
                        }}
                      >
                        <img
                          src={`${IMG_URL}/uploads/${product.image}`}
                          alt={product.product_name}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain", // 🔥 best for no crop
                          }}
                        />
                      </div>
                      <a
                        href="/"
                        className="quick-view-btn btn btn-dark QuickViewBtn"
                        onClick={(e) => handleQuickView(e, product)}
                      >
                        Quick View
                      </a>
                    </div>

                    <div className="d-flex justify-content-between align-items-start pt-3 px-1">
                      <div>
                        <a
                          href="/"
                          className="text-decoration-none text-muted d-block fw-medium text-truncate"
                          style={{ maxWidth: "180px" }} // width zaroori hai
                        >
                          {product.product_name}
                        </a>
                        <span className="text-bold" style={{fontWeight: "bold",}}>
                          ₹
                          {(() => {
                            try {
                              const rates = product.final_rate
                                ? JSON.parse(product.final_rate)
                                : [];
                              if (Array.isArray(rates) && rates.length) {
                                return (
                                  rates[0].finalRate ||
                                  rates[0].finalAmount ||
                                  "N/A"
                                );
                              } else {
                                return "N/A";
                              }
                            } catch {
                              return "N/A";
                            }
                          })()}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))
          ) : (
            <p className="text-center text-muted">No products found.</p>
          )}
        </div>
        <div className="d-flex justify-content-center w-100 pt-4">
          <Link to="/shop">
            <button className=" btn-dark text-uppercase text-white px-4 py-2 border  hover-effect">
              Load More
            </button>
          </Link>
        </div>
      </div>
      <ProductDetailsModal
        show={showModal}
        onClose={() => setShowModal(false)}
        product={selectedProduct}
      />
    </section>
  );
};

export default HomeProduct;
